import { render, staticRenderFns } from "./ModalConfirmOkOnly.vue?vue&type=template&id=664b8b59&scoped=true"
import script from "./ModalConfirmOkOnly.vue?vue&type=script&lang=js"
export * from "./ModalConfirmOkOnly.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmOkOnly.vue?vue&type=style&index=0&id=664b8b59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664b8b59",
  null
  
)

export default component.exports